import React from "react";
import { useNavigate } from "react-router-dom";
import "./JoinUs.css";
import pieChartImage from "../assets/img/PieChartImage.png";

const JoinUs = () => {
  const navigate = useNavigate();

  const handleContactRedirect = () => {
    navigate("/contact-us");
  };

  return (
    <div className="join-us-container">
      
      {/* Section 1: Chart Image */}
      <section className="chart-section" data-aos="zoom-in">
        <div className="chart-card">
          <h2 className="separator-title text-center"
          data-aos="fade-up"
          style={{ color: "#d4561a" }}>Our Network Ecosystem</h2>
          <div className="separator-line mb-5"></div>
          <img 
            src={pieChartImage} 
            alt="Membership Structure" 
            className="chart-image" 
          />
        </div>
      </section>

      {/* Section 2: Membership Table */}
      <section className="membership-section">
        <h2 
          className="separator-title text-center"
          data-aos="fade-up"
          style={{ color: "#d4561a" }}
        >
          Membership Plans
        </h2>
        <div className="separator-line mb-5"></div>

        <div className="table-container" data-aos="fade-up">
          <table className="membership-table">
            <thead>
              <tr>
                <th>Category</th>
                <th>Entry Fees (INR)</th>
                <th>Annual Membership Fees (INR)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Full Membership</td>
                <td>1,00,000</td>
                <td>20,000</td>
              </tr>
              <tr>
                <td>Associate Membership</td>
                <td>50,000</td>
                <td>15,000</td>
              </tr>
              <tr>
                <td>Affiliate Membership</td>
                <td>500</td>
                <td>10,000</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Section 3: Get Involved */}
      <section className="get-involved" data-aos="fade-up">
        <h2 className="separator-title text-center"
          data-aos="fade-up"
          style={{ color: "#d4561a" }}>Get Involved</h2>
          <div className="separator-line mb-5"></div>
        <p>
          Be a part of our growing network and help us make a lasting impact 
          in the agriculture and trade ecosystem. Your contribution matters!
        </p>
        <button 
          className="cta-button"
          onClick={handleContactRedirect}
        >
          Contact Us
        </button>
      </section>
    </div>
  );
};

export default JoinUs;
